class ScenarioChart {
  constructor(element, dataValue, dataRanked, classDraw) {
    let vis = this
    vis.initProps = {
      element,
      data: dataValue,
      dataRanked: dataRanked,
      classDraw: classDraw,
    }
  }

  setDimensions(width, height, margin = {}) {
    let vis = this
    if (vis.initProps?.element && vis.initProps?.data?.length) {
      vis.init({ ...vis.initProps, widthElement: width })
    }
  }
}

export default ScenarioChart
